import {useLocation} from 'react-router-dom'
import {Component as SimplifiedQuote} from '@pages/quote/SimplifiedQuote.tsx'
import {Component as SimplifiedQuotePdf} from '@pages/quote/SimplifiedQuotePdf.tsx'

const QuoteWrapper = () => {
    const location = useLocation()
    const isPDF = new URLSearchParams(location.search).get('pdf') === 'true'

    return isPDF ? <SimplifiedQuotePdf /> : <SimplifiedQuote />
}

export default QuoteWrapper
